module.exports = __webpack_public_path__ + "img/cartIllustartion.b832da94.svg";